/* TODO: t() */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';

import FormFieldEditor from '../helpers/FormFieldEditor';
import { TextInput, Text } from '../../../uiold';

import HeadingElement from '../HeadingElement';

type EditorViewProps = {
  data: {
    [key: string]: unknown;
  };
  updateValue: (key: string, newValue: unknown) => void;
};

function EditorView(props: EditorViewProps) {
  let { data, updateValue } = props;
  let onChange = (text: string) => {
    updateValue('text', text);
  };
  let text = typeof data.text === 'string' ? data.text : '';
  return (
    <View accessibilityRole="label">
      <Text style={styles.text}>Text</Text>
      <TextInput type="text" value={text} onChangeText={onChange} />
    </View>
  );
}

type Props = {
  parent: HeadingElement;
};

class HeadingElementFieldEditorView extends Component<Props> {
  render() {
    let { parent } = this.props;
    return <FormFieldEditor component={EditorView} parent={parent} />;
  }
}

const styles = StyleSheet.create({
  text: {
    fontWeight: 'normal',
    marginBottom: 5,
  },
});
export default HeadingElementFieldEditorView;
